import { string, object } from '@gogame/schemas';

import { NAME, OWNER, COUNTRY, ADDRESS } from './constants';

export const PartnerCompanyFormValidationSchema = object({
  [NAME]: string().required('Name  is required'),
  [OWNER]: string().required('Owner  is required'),
  [ADDRESS]: object({
    [COUNTRY]: string().required('Country  is required'),
  }),
});
